import { addMinutes } from 'date-fns';

import { toBRL, toCNPJ, toCPF, toReadableDate, toReadableNumber } from '@partiu/ui/formatters.ts';

export function DataGridBooleanFormatter({ value }: { value: boolean }) {
  return value ? 'Sim' : 'Não';
}

export function DataGridDateFormatter({ value }: { value: string }) {
  return value ? toReadableDate(value) : 'Não definido';
}

export function DataGridDateTimeFormatter({ value }: { value: string }) {
  if (!value) return 'Não definido';

  const date = typeof value === 'string' ? new Date(value) : value;
  return date.toLocaleString('pt-BR', {
    timeZone: 'UTC',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function DataGridCPFFormatter({ value }: { value: string }) {
  return value ? toCPF(value) : 'Não definido';
}

export function DataGridCNPJFormatter({ value }: { value: string }) {
  return value ? toCNPJ(value) : 'Não definido';
}

export function DataGridCPFCNPJFormatter({ value }: { value: string }) {
  if (!value) return 'Não definido';

  if (value.length === 14) return DataGridCNPJFormatter({ value });

  return DataGridCPFFormatter({ value });
}

export function DataGridCurrencyFormatter({ value }: { value: string }) {
  return toBRL(value || 0);
}

export function DataGridNumberFormatter({ value }: { value: string }) {
  return toReadableNumber(value || 0);
}

export function DataGridTextFormatter({ value }: { value: string }) {
  return value ? value : 'Não definido';
}

export function DataGridStaffLevelFormatter({ value }: { value: boolean }): string {
  return value ? 'Administrador' : 'Funcionário';
}


export function formatDate(date: Date): Date {
  return addMinutes(date, -date.getTimezoneOffset());
}
